module.exports = __webpack_public_path__ + "img/Bloque-Mobile-Embarcadoras.b3a0ba00.png";